export const MAX_EXPIRE_DATE_TIME = 253402297199000;
